<template>
  <div class="hkl-next-reviewer">
    <HKLModal
      ref="modal"
      class="hkl-next-reviewer__modal"
      :okBtnAction="okBtnAction"
      :beforeOkClick="validate"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template slot="title">
        <slot name="title" />
      </template>
      <div class="hkl-next-reviewer__selector">
        <HKLForm ref="formRef">
          <label
            class="hkl-next-reviewer__title"
            :class="{'required-flag': required}"
          >
            {{ title }}
          </label>
          <HKLSelect
            v-model="newReviewer"
            v-fusioninputcheck="{
              type: 'string',
              required: true,
              showTip: false,
            }"
            :showSearch="true"
            :options="options"
          />
        </HKLForm>
      </div>
      <div class="hkl-next-reviewer__add-text">
        <slot name="add-text" />
      </div>
    </HKLModal>
  </div>
</template>

<script>
import { ref, unref, computed } from '@vue/composition-api'
import HKLModal from '@/controls/Modal/HKLModal'
import { useRefModal } from '@/controls/Modal/modal.hook'
import HKLSelect from '@/controls/Select/HKLSelect'
import i18n from '@/utils/i18n'
import HKLForm from '../Form/HKLForm.vue'
import { useRefForm } from '../Form/hook'

export default {
  components: {
    HKLForm,
    HKLSelect,
    HKLModal,
  },
  props: {
    defaultOptions: {
      type: Array,
      default: () => [],
    },
    asyncSelectOptions: {
      type: Function,
      default: undefined,
    },
    title: {
      type: String,
      default: i18n.t('tenantProjects.submission.selectNextReviewer'),
    },
    okBtnAction: {
      type: String,
      default: 'submit',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    const modals = useRefModal()
    const { form: formRef, validate } = useRefForm()
    const options = ref(props.defaultOptions)
    const newReviewer = ref('')
    const open = async () => {
      newReviewer.value = ''
      if (typeof props.asyncSelectOptions === 'function') {
        options.value = await props.asyncSelectOptions()
      }
      modals.open()
    }
    const getSelectedValue = () => newReviewer.value
    return {
      formRef,
      validate,
      newReviewer,
      options: computed(() => unref(options).sort((a, b) => a.name.localeCompare(b.name))),
      modal: modals.modal,
      open,
      getSelectedValue,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/_settings.scss';

.hkl-next-reviewer {
  &__modal ::v-deep {
    .ant-modal-body {
      margin-top: 0;
    }
    .ant-select-selection .ant-select-search {
      height: 38px;
      line-height: 38px;
      font-size: 14px;
      font-family: $content-font-family;
    }
    .ant-select-dropdown-menu-item {
      font-weight: normal;
    }
  }
}
</style>
